import { isNil } from 'ramda';

export const addURLParameters = (params: { [key: string]: string | null }) => {
  const url = new URLSearchParams(window.location.search);
  Object.keys(params).forEach(key => url.delete(key));
  Object.keys(params).forEach(key => !isNil(params[key]) && url.append(key, params[key]));
  const urlString = url.toString();
  window.history.replaceState({}, '', `?${urlString}`);
};

export const removeURLParameters = (params: string[]) => {
  const url = new URLSearchParams(window.location.search);
  params.forEach(key => url.delete(key));
  const urlString = url.toString();
  window.history.replaceState({}, '', `?${urlString}`);
};
